<template>
  <button
    class="__button"
    :type="type"
    :class="checkClass()"
    @click="clickEvent($event)"
  >
    <slot name="icon-before"></slot>
    <span><slot></slot></span>
    <slot name="icon-after"></slot>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "button",
    },
    variant: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      result: [],
    };
  },

  methods: {
    clickEvent(event) {
      if (!this.disabled) {
        this.$emit("click", event);
      } else {
        return;
      }
    },

    checkClass() {
      let result = [];
      let index = result.findIndex((e) => e === "__disabled");
      if (this.variant != "") {
        result.push(`__${this.variant}`);
      }
      if (this.size != "") {
        result.push(`__${this.size}`);
      }
      if (this.disabled) {
        result.push(`__disabled`);
      } else if (!this.disabled && index != -1) {
        result.splice(index);
      }
      return result.join(" ");
    },
  },
};
</script>

<style lang="scss" scoped>
.__button {
  display: flex;
  flex-direction: row;
  align-items: center;
  place-content: center;
  padding: 16px;
  height: 44px;
  box-sizing: border-box;
  border-radius: 4px;

  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  background-color: #3e69f6;
  color: #fff;

  &.__sm {
    padding: 12px;
    height: 36px;
    border-radius: 3px;
  }
  //  Số nhập tự động code by Thằng DucVH
  &.__size100 {
    width: 100%;
  }

  svg,
  svg * {
    fill: #fff;
  }

  *:not(:first-child) {
    margin-left: 8px;
  }

  &.__outline {
    background-color: #fff;
    border: 1px solid #c7c9d1;
    color: #23313e;

    svg,
    svg * {
      fill: #23313e;
    }
  }
  &.__outline-none {
    background-color: #fff;
    // border: 1px solid #c7c9d1;
    color: #23313e;

    svg,
    svg * {
      fill: #23313e;
    }
  }

  &.__outline-dashed {
    border: 1px dashed #9eb4fa;
    background-color: transparent;
    color: #3e69f6;

    svg,
    svg * {
      fill: #3e69f6;
    }
  }

  &.__primary {
    background-color: #9eb3fa1a;
    color: #3e69f6;

    svg,
    svg * {
      fill: #3e69f6;
    }
  }

  &.__secondary {
    background-color: #ecf0fe;
    color: #3e69f6;

    svg,
    svg * {
      fill: #3e69f6;
    }
  }

  &.__danger {
    background-color: #fce7eb;
    color: #dc2323;

    svg,
    svg * {
      fill: #dc2323;
    }
  }

  &.__alert {
    background-color: #dc2323;
    color: #fff;

    svg,
    svg * {
      fill: #dc2323;
    }
  }

  &.__success {
    background-color: #3e69f6;
    color: #fff;

    svg,
    svg * {
      fill: #3e69f6;
    }
  }

  &.__disabled {
    background-color: #fff;
    color: #ddd;
    cursor: default !important;
    svg,
    svg * {
      fill: #ddd;
    }
  }

  &.__secondary-200 {
    background-color: #f2f3f4;
    color: #9093a4;

    svg,
    svg * {
      fill: #3e69f6;
    }
  }
}
</style>
